import React, { useState, useEffect } from "react";
import Datepicker from "../../fixedassetelements/datepicker/Datepicker";
import {
  AddregButton,
  FilterIcon,
  SyncButton,
  UploadButton,
} from "../../fixedassetelements/button/Button";

import SyncPopup from "../SyncButton/SyncButton";
import UploadExcelModal from "../common/UploadExcelModal/UploadExcelModal";
import CustomFilter from "../filterIcon/CustomFilter";
import AddSalesRegister from "../forms/AddSalesRegister/AddSalesRegister";
import UploadFile from "../forms/UploadFile/UploadFile";
import SalesUploadedFiles from "../forms/UploadedSalesFiles/UploadedSalesFiles";
import ColumnMapping from "../forms/ColumnMappingForm/ColumnMapping";
import Submapping from "../forms/SubMapping/Submapping";
import ERPModal from "../common/ERPModal/ERPModal";
import SyncERPSuccess from "../SyncButton/SyncERPSuccess";
import AppendReplaceFile from "../common/AppendReplacePopup/AppendReplacePopup";
import { salesListing } from "../../../Bookclosure/Services/ApiHandler";

import styles from "./SalesregHeader.module.css";

const SalesregHeader = ({
  setShowDataState,
  tableType,
  setTableType,
  setShowTable,
  onFiltersApplied,
  showAddRegisterModal,
  setShowAddRegisterModal,
}) => {
  const [fromDate, setFromDate] = useState("2024-01-01");
  const [toDate, setToDate] = useState("2025-01-01");

  //const [showAddRegisterModal, setShowAddRegisterModal] = useState(false);
  const [showUploadExcelModal, setShowUploadExcelModal] = useState(false);
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [showSalesUploadedFiles, setShowSalesUploadedFiles] = useState(false);
  const [showColumnMapping, setShowColumnMapping] = useState(false);
  const [showSubMapping, setShowSubMapping] = useState(false);
  const [showERPModal, setShowERPModal] = useState(false);
  const [showERPSuccessModal, setShowERPSuccessModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showAppendReplacePopup, setShowAppendReplacePopup] = useState(false);

  const [uploadAction, setUploadAction] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [SaleID] = useState("6916f64db2634815b26021fa");
  const [uploadType, setUploadType] = useState(null);

  const [filterConfig, setFilterConfig] = useState([]);

  useEffect(() => {
    const fetchFilterConfig = async () => {
      try {
        const response = await salesListing(SaleID, {
          page: 1,
          pageSize: 30,
          filters: [],
        });

        if (response.data && response.data.filterAndAlignment) {
          setFilterConfig(response.data.filterAndAlignment);
        }
      } catch (error) {
        console.error("Failed to fetch filter config:", error);
      }
    };

    if (SaleID) {
      fetchFilterConfig();
    }
  }, [SaleID]);

  const handleRemoveFile = (index) => {
    setUploadedFiles((prev) => {
      console.log("Removed file:", prev[index]?.name);
      const newFiles = prev.filter((_, i) => i !== index);
      return newFiles;
    });
  };

  const handleAddFiles = () => {
    setShowSalesUploadedFiles(false);
    setShowUploadFileModal(true);
  };

  const handleApplyFilter = (filters) => {
    console.log("Filters received:", filters);
    setShowFilter(false);

    setShowTable(true);
    setShowDataState(false);

    if (onFiltersApplied) {
      onFiltersApplied(filters);
    }
  };

  const handleSelect = (type) => {
    if (type === "uploadExcelModal") {
      setShowAddRegisterModal(false);
      setShowUploadExcelModal(true);
    } else if (type === "erp") {
      setShowAddRegisterModal(false);
      setShowERPModal(true);
    }
  };

  const handleSelectUploadType = (type) => {
    setUploadType(type);
    setShowUploadExcelModal(false);
    setShowUploadFileModal(true);
  };

  const handleProceedToSalesUploadedFiles = (files) => {
    setUploadedFiles((prev) => {
      console.log("Previous files:", prev);
      console.log("New files:", files);
      const combined = [...prev, ...files];
      console.log("Combined files:", combined);
      return combined;
    });
    setShowUploadFileModal(false);
    setShowSalesUploadedFiles(true);
  };

  const handleStartMapping = () => {
    setShowSalesUploadedFiles(false);
    setShowColumnMapping(true);
  };

  const handleContinueMapping = () => {
    setShowColumnMapping(false);
    setShowSubMapping(true);
  };

  const handleSubmitSubMapping = () => {
    setShowSubMapping(false);
    setShowSalesUploadedFiles(true);
  };

  const handleFinish = () => {
    setShowSalesUploadedFiles(false);
    setShowDataState(false);
    setTableType("excel");
    setShowTable(true);
  };

  const handleSuccessERPModal = () => {
    setShowERPModal(false);
    setShowERPSuccessModal(true);
  };

  const handleERPComplete = () => {
    setShowERPSuccessModal(false);
    setShowDataState(false);
    setTableType("erp");
    setShowTable(true);
  };

  const handleAppendReplaceSelect = (action) => {
    setUploadAction(action);
    setShowAppendReplacePopup(false);
    setShowUploadExcelModal(true);
  };

  return (
    <>
      <div className={styles.salesregheader_container}>
        <div className={styles.rightSection}>
          <FilterIcon onClick={() => setShowFilter(true)} />

          <Datepicker
            fromDate={fromDate}
            toDate={toDate}
            onFromChange={(e) => setFromDate(e.target.value)}
            onToChange={(e) => setToDate(e.target.value)}
          />

          {tableType === "erp" && (
            <SyncButton onClick={() => setShowPopup(true)} />
          )}
          {tableType === "excel" && (
            <UploadButton onClick={() => setShowAppendReplacePopup(true)} />
          )}
          {tableType === null && (
            <AddregButton onClick={() => setShowAddRegisterModal(true)} />
          )}
        </div>
      </div>

      {showAddRegisterModal && (
        <AddSalesRegister
          onClose={() => setShowAddRegisterModal(false)}
          handleSelect={handleSelect}
        />
      )}

      {showUploadExcelModal && (
        <UploadExcelModal
          onClose={() => setShowUploadExcelModal(false)}
          onBack={() => {
            setShowUploadExcelModal(false);
            setShowAddRegisterModal(true);
          }}
          onSelectUploadType={handleSelectUploadType}
        />
      )}

      {showUploadFileModal && (
        <UploadFile
          SaleID={SaleID}
          onClose={() => setShowUploadFileModal(false)}
          onBack={() => {
            setShowUploadFileModal(false);
            setShowUploadExcelModal(true);
          }}
          onProceed={handleProceedToSalesUploadedFiles}
        />
      )}

    
      {showSalesUploadedFiles && (
        <SalesUploadedFiles
          uploadedFiles={uploadedFiles}
          onBack={() => {
            setShowSalesUploadedFiles(false);
            setShowUploadFileModal(true);
          }}
          onStartMapping={handleStartMapping}
          onFinish={handleFinish}
          onClose={() => setShowSalesUploadedFiles(false)}
          onRemove={handleRemoveFile}
          onAdd={handleAddFiles}
        />
      )}

      {showColumnMapping && (
        <ColumnMapping
          SaleID={SaleID}
          onBack={() => {
            setShowColumnMapping(false);
            setShowSalesUploadedFiles(true);
          }}
          onContinue={handleContinueMapping}
          onClose={() => setShowColumnMapping(false)}
          onCancel={() => {
            setShowColumnMapping(false);
            setShowSalesUploadedFiles(true);
          }}
        />
      )}

      {showSubMapping && (
        <Submapping
          SaleID={SaleID}
          onBack={() => {
            setShowSubMapping(false);
            setShowColumnMapping(true);
          }}
          onSubmitMapping={handleSubmitSubMapping}
          onClose={() => setShowSubMapping(false)}
          onCancel={() => {
            setShowSubMapping(false);
            setShowSalesUploadedFiles(true);
          }}
        />
      )}

      {showERPModal && (
        <ERPModal
          onClose={() => setShowERPModal(false)}
          onBack={() => {
            setShowERPModal(false);
            setShowAddRegisterModal(true);
          }}
          onProceed={handleSuccessERPModal}
        />
      )}

      {showERPSuccessModal && <SyncERPSuccess onClose={handleERPComplete} />}

      {showFilter && (
        <CustomFilter
          onClose={() => setShowFilter(false)}
          onApply={handleApplyFilter}
          filterConfig={filterConfig}
        />
      )}

      {showPopup && <SyncPopup onClose={() => setShowPopup(false)} />}

      {showAppendReplacePopup && (
        <AppendReplaceFile
          onClose={() => setShowAppendReplacePopup(false)}
          onSelectUploadType={handleAppendReplaceSelect}
        />
      )}
    </>
  );
};

export default SalesregHeader;
